import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { PriceStore } from '../stores/PriceStore';
import { SessionActions } from '../actions/SessionActions';
import { ProjectSettingsActions } from '../actions/ProjectSettingsActions';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { PconLoginStore } from '../stores/PconLoginStore';
import { ProjectSettingsStore } from '../stores/ProjectSettingsStore';

export class SelectionCurrency extends SelectionBase {
    protected showValueInApp: boolean = true;
    protected id: string = 'currency-select';

    public componentWillMount(): void {
        this.addStoreListener(PconLoginStore, this.onChange);
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: ProjectSettingsStore.getState().currency,
            visible: PconLoginStore.pricesEnabled() && ProjectSettingsStore.isChangeable('currency'),
            enabled: ProjectSettingsStore.getState().articleListPrices === 'show'
        });
    };

    protected setCurrency(currency: string): void {
        if (PriceStore.isCurrencyValid(currency)) {
            SessionActions.setCurrency(currency).then(() => {
                ProjectSettingsActions.setCurrency(currency);
            });
        }
    }

    protected getLabel(): string {
        return t('Currency');
    }

    protected options(): Array<SelectBoxOption> {
        const tempArray: Array<string> = [];
        const result: Array<SelectBoxOption> = [];
        PriceStore.getState().exchangeRates.forEach((value: number, index: string, map: Map<string, number>) => {
            tempArray.push(index);
        });
        for (const currencyName of tempArray.sort(
            (a: string, b: string) => {
                if (a > b) {
                    return 1;
                }
                if (b > a) {
                    return -1;
                }
                return 0;
            })) {
                result.push(
                    {name: currencyName, className: 'egr-select-option-noicon', key: currencyName, callback: () => {this.setCurrency(currencyName); }}
                );
            }
        return result;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionCurrency.tsx